"use client"
/* */
const formField = "flow--form-field";
const label = "flow--form-field--label";
const fieldError = "flow--form-field--field-error";
const customFieldError = "flow--form-field--custom-field-error";
const fieldDescription = "flow--form-field--field-description";
const formFieldStyles = {
	formField: formField,
	label: label,
	fieldError: fieldError,
	customFieldError: customFieldError,
	fieldDescription: fieldDescription
};

export { customFieldError, formFieldStyles as default, fieldDescription, fieldError, formField, label };
//# sourceMappingURL=FormField.module.scss.mjs.map
